/**
 * @flow
 */
import React, { Component } from 'react';
import {
  Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink,
  Button, Popover, PopoverHeader, PopoverBody,
} from 'reactstrap';
import { Link } from 'react-router';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { translate  } from 'react-i18next';
import { NavbarLanguageToggler } from './NavbarLanguageToggler';
import NavBrand from './NavBrand';
import Settings from '../../Store/Settings';
import ContactDropdown from './ContactDropdown';

type Props = {
  onLangChanged: (lang: string) => void,
  t: any,
};

@observer
export class Header extends React.Component<Props> {
  @observable isOpen: boolean = false;

  toggle = () => {
    this.isOpen = !this.isOpen;
  };

  render() {
    const { t } = this.props;
    const { settings } = Settings;

    return (
      <Navbar color='faded' light expand='md'>
        <div className='header-wrapper'>
          <div className='d-inline-block d-md-none'>
            <NavbarLanguageToggler onLangChanged={this.props.onLangChanged} />
          </div>

          <div className="logo-container d-inline-block align-items-left">
            <NavBrand />
          </div>

          <NavbarToggler onClick={this.toggle} />

          <Collapse isOpen={this.isOpen} navbar className="justify-content-center">
            <Nav navbar className="justify-content-center nav-item-spacing">
              <NavItem>
                <Link className='nav-link' to='/'>{t('Flug Buchen')}</Link>
              </NavItem>
              {settings.has('enable_flight_requests') && settings.get('enable_flight_requests') > 0 &&
                <NavItem>
                  <Link className='nav-link' to='/request-flight'>{t('Request a Flight')}</Link>
                </NavItem>
              }
              {settings.has('voucher_template_file_id') && settings.get('voucher_template_file_id') > 0 &&
                <NavItem>
                  <Link className='nav-link' to='/voucher'>{t('Gift Certificates')}</Link>
                </NavItem>
              }
              <NavItem className='d-flex d-md-none'>
                {(settings.get('email') || settings.get('phone') || settings.get('locations') || settings.get('contact_info')) &&
                  <ContactDropdown />
                }
              </NavItem>
            </Nav>
          </Collapse>

          <div className='d-none d-md-flex align-items-center ml-auto'>
            {(settings.get('email') || settings.get('phone') || settings.get('locations') || settings.get('contact_info')) &&
              <ContactDropdown />
            }
            <NavbarLanguageToggler onLangChanged={this.props.onLangChanged} />
          </div>
        </div>
      </Navbar>

    );
  }
}

export default translate()(Header);



// WEBPACK FOOTER //
// ./src/App/Layout/Header/index.js